const REFERRAL_STORAGE_KEY = "uprasti_referral_code";
const REFERRAL_COOKIE_KEY = "uprasti_referral_code";
const REFERRAL_MAX_AGE_DAYS = 30;

function canUseWindow() {
  return typeof window !== "undefined";
}

export function sanitizeReferralCode(value) {
  const code = String(value || "").trim();

  if (!code) return "";

  const safeCode = code.replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 64);

  return safeCode.length >= 3 ? safeCode : "";
}

export function saveReferralCode(referralCode) {
  const safeCode = sanitizeReferralCode(referralCode);

  if (!safeCode || !canUseWindow()) return "";

  try {
    window.localStorage.setItem(REFERRAL_STORAGE_KEY, safeCode);
  } catch (_) {}

  try {
    const maxAge = REFERRAL_MAX_AGE_DAYS * 24 * 60 * 60;
    document.cookie = `${REFERRAL_COOKIE_KEY}=${encodeURIComponent(safeCode)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  } catch (_) {}

  return safeCode;
}

export function getSavedReferralCode() {
  if (!canUseWindow()) return "";

  try {
    const fromStorage = sanitizeReferralCode(
      window.localStorage.getItem(REFERRAL_STORAGE_KEY)
    );

    if (fromStorage) return fromStorage;
  } catch (_) {}

  try {
    const cookies = String(document.cookie || "").split(";");
    const referralCookie = cookies.find((item) =>
      item.trim().startsWith(`${REFERRAL_COOKIE_KEY}=`)
    );

    if (!referralCookie) return "";

    return sanitizeReferralCode(
      decodeURIComponent(referralCookie.split("=").slice(1).join("="))
    );
  } catch (_) {
    return "";
  }
}

export function clearSavedReferralCode() {
  if (!canUseWindow()) return;

  try {
    window.localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch (_) {}

  try {
    document.cookie = `${REFERRAL_COOKIE_KEY}=; path=/; max-age=0; SameSite=Lax`;
  } catch (_) {}
}

export function captureReferralCodeFromLocation(search = "") {
  if (!canUseWindow()) return "";

  const queryString = search || window.location.search || "";
  const params = new URLSearchParams(queryString);
  const referralCode =
    params.get("ref") || params.get("referral") || params.get("referralCode");

  return saveReferralCode(referralCode);
}

export function appendReferralCodeToPayload(payload = {}) {
  const referralCode = getSavedReferralCode();

  if (!referralCode) return payload;

  return {
    ...payload,
    referralCode,
  };
}
